// extracted by mini-css-extract-plugin
export var label = "_3s-1";
export var reminder = "_3s-0";